import type { ExtractPropTypes, PropType } from 'vue';
import { computed, ref } from 'vue';
import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import { getDescriptionContent } from '@getaccept/editor-lib';
import type { Milestone, Task } from '../types/action-plan';
import MilestoneHelper from '../helpers/milestone.helper';

export const milestoneProps = {
  milestone: {
    type: Object as PropType<Milestone>,
    required: true,
  },
};

export function useMilestone(props: ExtractPropTypes<typeof milestoneProps>) {
  const taskToEdit = ref(null);
  const showTaskDrawer = ref(false);
  const expanded = ref(true);
  const { isSmallScreenAndDown } = useBreakpoints();

  const progress = computed(() => MilestoneHelper.getMilestoneProgress(props.milestone));

  const formattedDescription = computed(() => getDescriptionContent(props.milestone.description));

  const handleOpenTaskDrawer = (task: Task) => {
    taskToEdit.value = task;
    showTaskDrawer.value = true;
  };

  const showTaskOwnersModal = ref(false);

  return {
    taskToEdit,
    showTaskDrawer,
    expanded,
    isSmallScreenAndDown,
    formattedDescription,
    progress,
    showTaskOwnersModal,

    handleOpenTaskDrawer,
  };
}
